import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-height" }
const _hoisted_2 = { class: "text-h6 text-navy-700 q-pt-md" }
const _hoisted_3 = { class: "text-body1" }
const _hoisted_4 = { class: "text-h6 text-navy-700 q-pt-md" }

import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import SfxCurrentUserDisplay from "src/components/special/SfxCurrentUserDisplay.vue"
import SfxSettingsField from "src/components/special/SfxSettingsField.vue"
import { useApiCallStore } from "src/stores/apiCallStore"
import { useAuthStore } from "src/stores/authStore"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useUserStore } from "src/stores/userStore"
import { LANGUAGE_LIST } from "src/util/constants/configurations"
import { SpringboardURL } from "src/util/enums/urls"
import { changePasswordDialog, changeUnlockKeyDialog } from "src/util/functions/dialogs"
import { computed, onBeforeMount } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsInformation',
  emits: ["closeDialog"],
  setup(__props, { emit: __emit }) {

const emit = __emit

//endregion

//region Variables

const authStore = useAuthStore()
const configurationStore = useConfigurationStore()
const userStore = useUserStore()
const apiCallStore = useApiCallStore()

const selectLanguage = computed({
  get: () => configurationStore.language,
  set: (value) => {
    configurationStore.language = value
  },
})
const languageList = LANGUAGE_LIST
const isExternallyLoggedIn = computed(() => authStore.sso)

//endregion

//region Lifecycle

onBeforeMount(async () => {
  if (apiCallStore.canCallAgain(SpringboardURL.USER_ME)) await userStore.fetchUserData()
})

//endregion

//region Functions

function disableUnusedLanguages(language: string) {
  return language !== LANGUAGE_LIST[0]
}

function showPasswordChangeDialog() {
  emit("closeDialog")
  changePasswordDialog()
}

function showUnlockKeyChangeDialog() {
  emit("closeDialog")
  changeUnlockKeyDialog()
}

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SfxCurrentUserDisplay, { "change-picture": "" }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("sfxDialogUserSettings.title_security")), 1),
    (!isExternallyLoggedIn.value)
      ? (_openBlock(), _createBlock(SfxSettingsField, {
          key: 0,
          label: _ctx.$t('sfxDialogUserSettings.set_password'),
          clickable: "",
          onClick: showPasswordChangeDialog
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createVNode(SfxSettingsField, {
      label: _ctx.$t('sfxDialogUserSettings.set_unlock_key'),
      clickable: "",
      onClick: showUnlockKeyChangeDialog
    }, null, 8, ["label"]),
    _createVNode(SfxBtnLink, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logout())),
      dense: false,
      color: "negative",
      class: "q-pa-none"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("sfxButtons.btn_sign_out")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("sfxDialogUserSettings.title_interface")), 1),
    _createVNode(SfxSelect, {
      modelValue: selectLanguage.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectLanguage).value = $event)),
      label: _ctx.$t('sfxDialogUserSettings.language_select_label'),
      options: _unref(languageList),
      "option-disable": disableUnusedLanguages
    }, null, 8, ["modelValue", "label", "options"])
  ]))
}
}

})